// import config from './config';
import { authHeader } from "../helpers/authHeader.js";
import Axios from "axios";
import { config } from "../helpers";

export const googleMapsService = {
  calculateRoute
};

function calculateRoute(pickup, delivery) {
  const requestOptions = {
    method: "POST",
    headers: authHeader()
  };
  const body = {
    origin: pickup.address,
    destination: delivery.address
  };
  return Axios.post(
    `${config.apiUrlDirections}/Directions/CalculateRoute`,
    body,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  if (response.status != "200") {
    const error = response.statusText;
    return Promise.reject(error);
  }
  return response.data;
}
